export default "__VITE_ASSET__BOuXL49q__"